import regularAppService from "./regularAppService";

export const getCustomersPage = async ({
  page,
  limit,
  search,
  sortBy = "updatedAt",
  sortOrder = "desc",
  filter,
} = {}) => {
  const isValidSearch = typeof search === "string" && search.trim().length > 0;
  const result = await regularAppService.getPaginated({
    collection: "customers",
    ...(Number.isFinite(Number(page)) ? { page: Number(page) } : {}),
    ...(Number.isFinite(Number(limit)) ? { limit: Number(limit) } : {}),
    ...(isValidSearch ? { search } : {}),
    sortBy,
    sortOrder,
    ...(filter && typeof filter === "object" ? { filter } : {}),
  });
  return result;
};

export const updateCustomer = async ({
  customerId,
  name,
  userId,
  email,
  phone,
  notes,
}) => {
  const updatedCustomer = {
    _id: customerId,
    name,
    userId,
    email,
    phone,
    notes,
    updatedAt: new Date().toISOString(),
  };

  const result = await regularAppService.upsert({ collection: "customers", data: updatedCustomer });
  return result;
};

export const createCustomer = async ({ name, userId, email, phone, notes }) => {
  
  const newCustomer = {
    name,
    userId,
    email,
    phone,
    notes,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  };
  const result = await regularAppService.upsert({ collection: "customers", data: newCustomer });
  return result;
};

export const getCustomers = async ({ userId = "", query = {} }) => {
  const page = await regularAppService.getPaginated({ collection: "customers", page: 1, limit: 100 });
  return Array.isArray(page.items) ? page.items : [];
};

export const deleteCustomer = async (customerId) => {
  const customers = await getCustomers({});
  const customer = customers.find((c) => c._id === customerId);

  if (!customer) {
    throw new Error("Customer not found");
  }

  const deletedCustomer = {
    ...customer,
    deleted: true,
    updatedAt: new Date().toISOString(),
  };

  const result = await regularAppService.upsert({ collection: "customers", data: deletedCustomer });
  return result;
};

export const searchCustomers = async ({ search = "" }) => {
  const isValid = typeof search === "string" && search.trim().length > 0;
  const pageResult = await regularAppService.getPaginated({
    collection: "customers",
    ...(isValid ? { search } : {}),
  });
  return pageResult.items || [];
};

// Method to force a sync with the server
export const syncCustomers = async () => {
  return await getCustomers({});
};

// Debugging function to reset and check customer data
export const debugCustomers = async () => {
  return [];
};
